import { loadInfo } from '@/api/index'

export function getArg () {
  return loadInfo.request({
    method: 'post',
    url: '/GetArg'
  })
}

export function selectVehicleXinghao () {
  return loadInfo.request({
    method: 'post',
    url: '/selectVehicleXinghao'
  })
}
export function GetConsignee (data: any) {
  return loadInfo.request({
    method: 'post',
    url: '/GetConsignee',
    data
  })
}
